import React, { useState } from 'react';
import { View } from 'react-native-web';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Title } from 'app/src/styles';

import { FIELDS } from './new';
import { UPDATE_MAIL_FORWARD } from './queries';

const EditMailForward = ({ mailForward, setShow, refetch, domains }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: mailForward })
  });

  const [updateUser] = useMutation(UPDATE_MAIL_FORWARD, {
    onCompleted: () => {
      refetch();
      setShow(false);
    },
    onError: () => {
      setFormStatus(null);
    }
  });

  const onSubmit = input => {
    setFormStatus('submitting');

    updateUser({
      variables: { id: mailForward.id, ...prepareInput(input, FIELDS) }
    });
  };

  const fields = { ...FIELDS };

  fields.domainId = {
    ...fields.domainId,
    select: [{ value: '', label: 'Select' }, ...domains],
  };

  return (
    <Modal title="Update Email Forward" setShow={setShow}>
      <Fields fields={fields} control={control} errors={errors} />

      <Button
        label="Update Email Forward"
        onPress={handleSubmit(onSubmit)}
        disabled={'submitting' === formStatus}
        wide
      />
    </Modal>
  );
};

export default EditMailForward;
